module.exports = __webpack_public_path__ + "img/backgroundIcon.d4f5b2b.svg";